<template>
  <b-modal
    ref="modal"
    hide-footer
    hide-header
    size="md"
    @hidden="$emit('hidden')"
    modal-class="confirmation-modal-body"
  >
    <div class="confirmation-modal">
      <div class="confirmation-message" v-html="message"></div>
      <div class="confirmation-buttons">
        <button class="btn btn-secondary cancel-button" @click="cancel">
          キャンセル
        </button>
        <button class="btn btn-danger confirm-button" @click="confirm">
          {{ confirmBtnText }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: {
    message: {
      type: String,
      required: true,
    },
    modal_data: {
      id: String,
    },
    fromMessageTemplate: {
      type: Boolean,
      default: false,
    },
    confirmBtnText: {
      type: String,
      required: false,
      default: '削除する',
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    cancel() {
      this.$emit('cancel');
      this.hide();
    },
    confirm() {
      if (this.fromMessageTemplate) {
        this.confirmDelete(this.modal_data.id);
      } else {
        this.$emit('confirm');
      }
      this.hide();
    },
    confirmDelete(id) {
      this.$emit('confirm-delete', id);
    },
  },
};
</script>

<style scoped>
.confirmation-modal {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;
}

.confirmation-message {
  font-size: 24px;
  color: #333;
  text-align: center;
  margin-top: 60px;
  font-weight: bold;
  white-space: pre-line;
}

.confirmation-buttons {
  display: flex;
  justify-content: space-evenly;
  margin-top: auto;
  padding-top: 2rem;
}

.cancel-button {
  background-color: #ffffff;
  border-color: #3c3c3c;
  border-radius: 2px;
  min-width: 175px;
  width: 175px;
  color: #3c3c3c;
}

.confirm-button {
  background-color: #eb5757;
  border-color: #eb5757;
  border-radius: 2px;
  min-width: 175px;
  width: 175px;
}
</style>
